export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Даулы бағандар"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Қалпына келтіру"])}
}